import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { refundOrderList } from "@/api/dataAll/orderDisplay";
import addLinks from "./components/addLinks";
import clipboard from "@/utils/clipboard";
export default {
  name: "orderRefund",
  components: {
    addLinks: addLinks
  },
  mixins: [tabulation],
  data: function data() {
    return {
      value2: [],
      total: 0,
      pagrSize: 10,
      searchData: {
        page: 1,
        page_size: 10,
        order_id: ''
      },
      tableData: [],
      intReq: [],
      adPlacementSingleChoice: true,
      more: true,
      exportLoading: false
    };
  },
  created: function created() {},
  methods: {
    toUserDetail: function toUserDetail(item) {
      var _this = this;

      var menu = JSON.parse(window.localStorage.getItem('Menu'));
      var isauthority = false;
      menu.forEach(function (element) {
        element.son_menu.forEach(function (k) {
          if (k.url.indexOf('gmTool/playerDetails/playerDetails') > -1 && _this.rawData.game_mark.indexOf('royalpirates') > -1 || k.url.indexOf('gmToolNew/playerDetails_yujian/playerDetails_yujian') > -1 && _this.rawData.game_mark.indexOf('yjfm') > -1) {
            isauthority = true;
          }
        });
      });

      if (!isauthority) {
        this.$message.success(this.$t('noPermission'));
      } else {
        if (this.rawData.game_mark.indexOf('royalpirates') > -1) {
          this.$router.push({
            name: 'playerDetails',
            params: item
          });
        } else if (this.rawData.game_mark.indexOf('yjfm') > -1) {
          this.$router.push({
            name: 'playerDetails_yujian',
            params: item
          });
        }
      }
    },
    searchClick: function searchClick(e) {
      var _this2 = this;

      this.reqLoading = true;
      this.searchData.starttime = this.value2[0] || '';
      this.searchData.endtime = this.value2[1] || '';
      this.searchData.kind = 1;
      this.searchData.page = e;
      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == 'valuets' ? [''] : searchData.ad_placement;
      refundOrderList(_objectSpread(_objectSpread({}, searchData), this.defaultData())).then(function (res) {
        if (res.status == 200) {
          // if(!res.data.data){
          //   res.data.data = []
          // }
          res.data.data.map(function (item) {
            item.timestamp = _this2.$times.timestampToTime(item.timestamp);
            item.amount = item.amount ? _this2.$utils.conversion(item.amount).toFixed(2) : '0.00';
          });
          _this2.last_page = res.data.last_page;
          var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
          _this2.tableData = res.data.data.length ? _this2.$utils.dataConversion(res.data.data, list) : [];
          _this2.total = res.data.total - 0 || 0;

          _this2.$nextTick(function () {
            _this2.getTableRight();
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    handleSource: function handleSource(id, num) {
      var _this3 = this;

      this.addWayConfig = true;
      this.$nextTick(function () {
        _this3.$refs.addWayConfig.init(id, num);
      });
    },
    handleClipboard: function handleClipboard(text, event) {
      clipboard(text, event);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    mereList: function mereList() {
      var _this4 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
          var list;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this4.exportLoading = true;
                  list = [];
                  _context.next = 4;
                  return refundOrderList(_objectSpread(_objectSpread({}, _this4.searchData), {}, {
                    page_size: -1
                  }, _this4.defaultData())).then(function (res) {
                    if (res.status == 200) {
                      res.data.map(function (item) {
                        item.timestamp = _this4.$times.timestampToTime(item.timestamp);
                        item.amount = item.amount ? _this4.$utils.conversion(item.amount).toFixed(2) : '0.00';
                      });
                      var lists = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
                      list = [].concat(_toConsumableArray(list), _toConsumableArray(res.data.length ? _this4.$utils.dataConversion(res.data, lists) : []));
                    }
                  }).finally(function () {
                    _this4.exportLoading = false;
                  });

                case 4:
                  resolve(list);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    exportdata: function exportdata() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var list, columns, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.mereList();

              case 2:
                list = _context2.sent;
                columns = [{
                  label: _this5.$t('game'),
                  prop: 'game_reveal'
                }, {
                  label: _this5.$t('platform'),
                  prop: 'platform_reveal'
                }, {
                  label: _this5.$t('channel'),
                  prop: 'channel_reveal'
                }, {
                  label: _this5.$t('pkg'),
                  prop: 'pkg_reveal'
                }, {
                  label: _this5.$t('adChannel'),
                  prop: 'ad_channel_reveal'
                }, {
                  label: _this5.$t('adPlacement'),
                  prop: 'ad_placement_reveal'
                }, {
                  label: _this5.$t('userId'),
                  prop: 'user_id'
                }, {
                  label: _this5.$t('deviceId'),
                  prop: 'device_id'
                }, {
                  label: _this5.$t('serverId'),
                  prop: 'server_id'
                }, {
                  label: _this5.$t('refundTime'),
                  prop: 'new_date'
                }, {
                  label: _this5.$t('refundAmount'),
                  prop: 'amount'
                }, {
                  label: _this5.$t('orderId'),
                  prop: 'order_id'
                }, {
                  label: _this5.$t('refundReason'),
                  prop: 'reason'
                }];
                data = list;

                _this5.$export.excel({
                  columns: columns,
                  data: data,
                  title: _this5.$route.meta.title
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};